import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { CASES, TIER_META, fmtUsd } from "../../data/casesData";
import ItemImage from "./ItemImage";
import { Package, ChevronRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ICON_MAP = {};
CASES.forEach((c) => c.items.forEach((i) => { ICON_MAP[i.name] = i.icon; }));

export default function LiveDropsStrip() {
  const [feed, setFeed] = useState([]);
  const scroller = useRef(null);

  const load = async () => {
    try {
      const { data } = await axios.get(`${API}/live-drops`);
      setFeed(data.drops || []);
    } catch (_) { /* keep last */ }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 6000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div data-testid="live-drops-strip" className="flex items-center gap-3 rounded-2xl border border-[var(--uc-border)] bg-[var(--uc-rail)]/60 px-3 py-2.5">
      <div className="flex shrink-0 items-center gap-2 pr-2">
        <span className="live-dot h-2.5 w-2.5 rounded-full bg-[var(--uc-green)]" />
        <span className="text-xs font-bold uppercase tracking-wider text-white">Live drops</span>
      </div>
      <div ref={scroller} className="no-scrollbar flex flex-1 items-center gap-2.5 overflow-x-auto">
        {feed.map((d, idx) => {
          const meta = TIER_META[d.tier] || TIER_META.common;
          const color = meta.color;
          const item = { name: d.name, tier: d.tier, value: d.value, icon: ICON_MAP[d.name] || Package };
          return (
            <div key={`${d.won_at}_${idx}`} data-testid="live-drop-tile"
              className="group flex shrink-0 items-center gap-2.5 rounded-xl border border-[var(--uc-border)] bg-[var(--uc-card)] px-2.5 py-1.5 transition-colors hover:border-[var(--uc-border-active)]">
              <div className="relative flex h-11 w-11 shrink-0 items-center justify-center overflow-hidden rounded-lg"
                style={{ background: `${color}26`, boxShadow: `inset 0 -14px 20px -12px ${color}` }}>
                <ItemImage item={item} imgClass="h-9 w-9" iconClass="h-6 w-6" color={color} />
              </div>
              <div className="min-w-0 pr-1">
                <div className="truncate text-[11px] font-bold" style={{ color }}>{fmtUsd(d.value)}</div>
                <div className="max-w-[92px] truncate text-[10px] text-[var(--uc-muted)]">{d.user}</div>
              </div>
            </div>
          );
        })}
      </div>
      <button
        onClick={() => scroller.current?.scrollBy({ left: 260, behavior: "smooth" })}
        className="hidden h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[var(--uc-border)] bg-white/5 text-white hover:bg-white/10 sm:flex"
        aria-label="Scroll drops">
        <ChevronRight className="h-4 w-4" />
      </button>
    </div>
  );
}
